import {Card} from 'platform/components';
import {Grid, Text, ThemeIconKey, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {MessageRequirementItem} from '../../../components/MessageRequirementItem/MessageRequirementItem';

interface SharedRequirement {
  icon: ThemeIconKey;
  title: string;
  description: string;
}

const SHARED_REQUIREMENTS: SharedRequirement[] = [
  {
    icon: 'action/power_settings_new',
    title: i18n.t('page.settings.scheduledMessages.sharedRequirements.enabled.title'),
    description: i18n.t('page.settings.scheduledMessages.sharedRequirements.enabled.description'),
  },
  {
    icon: 'action/markunread_mailbox',
    title: i18n.t('page.settings.scheduledMessages.sharedRequirements.mailbox.title'),
    description: i18n.t('page.settings.scheduledMessages.sharedRequirements.mailbox.description'),
  },
  {
    icon: 'social/person',
    title: i18n.t('page.settings.scheduledMessages.sharedRequirements.contact.title'),
    description: i18n.t('page.settings.scheduledMessages.sharedRequirements.contact.description'),
  },
  {
    icon: 'action/subject',
    title: i18n.t('page.settings.scheduledMessages.sharedRequirements.template.title'),
    description: i18n.t('page.settings.scheduledMessages.sharedRequirements.template.description'),
  },
  {
    icon: 'action/event',
    title: i18n.t('page.settings.scheduledMessages.sharedRequirements.daysBefore.title'),
    description: i18n.t(
      'page.settings.scheduledMessages.sharedRequirements.daysBefore.description'
    ),
  },
];

export function SharedRequirementsCard(props: TestIdProps) {
  return (
    <Card
      variant="inlineGrey"
      title={i18n.t('page.settings.scheduledMessages.sharedRequirements.title')}
      isExpandable
      data-testid={suffixTestId('sharedRequirements', props)}
    >
      <VStack spacing={4}>
        <Text size="small" color="secondary">
          {i18n.t('page.settings.scheduledMessages.sharedRequirements.description')}
        </Text>
        <Grid columns={[1, 1, 2, 3]} spacing={4}>
          {SHARED_REQUIREMENTS.map((requirement, index) => (
            <MessageRequirementItem
              key={requirement.icon}
              icon={requirement.icon}
              title={requirement.title}
              description={requirement.description}
              data-testid={suffixTestId(`sharedRequirements-[${index}]`, props)}
            />
          ))}
        </Grid>
      </VStack>
    </Card>
  );
}
